import { Component, OnInit } from '@angular/core';
import { ISiteSetting } from 'src/app/shared/interfaces/siteSetting';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.css'
})
export class PrivacyComponent implements OnInit{

  privacy: ISiteSetting;


  constructor(private apiService: ApiService) {}


  ngOnInit(): void {
    this.getContent()
  }

  getContent() {
    this.apiService.apiCall('get', '/api/SiteInfo/Privacy').subscribe((res: any) => {
      console.log(res);
      
      this.privacy = res.body.model;
    })
  }
  
}
